import { isValidElement, type ComponentPropsWithoutRef, type ReactNode } from "react";
import type { Components } from "react-markdown";

function markdownChildrenToPlainText(node: ReactNode): string {
  if (node == null || typeof node === "boolean") return "";
  if (typeof node === "string" || typeof node === "number") return String(node);
  if (Array.isArray(node)) return node.map(markdownChildrenToPlainText).join("");
  if (isValidElement(node)) {
    const ch = (node.props as { children?: ReactNode }).children;
    return markdownChildrenToPlainText(ch);
  }
  return "";
}

function OpAiChatH3(props: ComponentPropsWithoutRef<"h3">) {
  const { children, className, ...rest } = props;
  const plain = markdownChildrenToPlainText(children)
    .trim()
    .replace(/\s+/g, " ");
  const isQuestions = /^questions for you$/i.test(plain);
  const merged = [className, isQuestions ? "opAiChatQuestionsHeading" : null].filter(Boolean).join(" ");
  return (
    <h3 {...rest} className={merged || undefined}>
      {children}
    </h3>
  );
}

/** Highlights the \`### Questions for you\` + list convention from hub prompts. */
export const opAiChatMarkdownComponents = {
  h3: OpAiChatH3
} satisfies Partial<Components>;
